import { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import Button from '@/components/button/Button';
import { theme } from '@/styles/theme';
import { styles } from './styles';

interface WarningFieldProps {
  description: string;
  isHidden: boolean;
  status: 'success' | 'warning';
  leftButtonTitle?: string;
  rightButtonTitle: string;
  leftButtonAction?: (() => void) | null;
  rightButtonAction: () => void;
  setShowWarning?: (show: boolean) => void;
}

const WarningField = ({
  description,
  isHidden,
  status,
  leftButtonTitle = '',
  rightButtonTitle,
  leftButtonAction = null,
  rightButtonAction,
  setShowWarning,
}: WarningFieldProps) => {
  const time = 5 * 1000;

  useEffect(() => {
    if (!isHidden) {
      const timer = setTimeout(
        () => setShowWarning && setShowWarning(false),
        time
      );
      return () => clearTimeout(timer);
    }
  }, [isHidden]);

  return !isHidden ? (
    <Box
      sx={{
        ...styles.container,
        backgroundColor:
          status === 'success'
            ? theme.palette.warning.contrastText
            : status === 'warning'
            ? theme.palette.primary.light
            : 'transparent',
      }}
    >
      <Box style={styles.content}>
        <Typography
          sx={{
            fontSize: '1.2rem',
            color: status === 'success' ? 'white' : null,
          }}
        >
          {description}
        </Typography>
      </Box>
      <Box style={styles.buttonContainer}>
        <Button
          title={leftButtonAction == null ? '' : leftButtonTitle}
          onlyText={true}
          onClick={() => {
            if (leftButtonAction != null) {
              leftButtonAction();
            }
          }}
          disable={leftButtonAction == null}
          loading={false}
        />

        <Button
          title={rightButtonTitle}
          onlyText={true}
          onClick={() => rightButtonAction()}
          disable={false}
          loading={false}
        />
      </Box>
    </Box>
  ) : null;
};

export default WarningField;
